"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'jiekuanTable',
  props: {
    tableData: {
      type: Object,
      required: true
    },
    tableName: {
      type: String,
      default: '分类'
    }
  }
};